import { UIHeading2, UIHeading4, UIText2 } from '@cian/ui-kit';
import { IconFinanceArrowBoldDown16 } from '@cian/ui-kit-design-tokens/icons';
import * as React from 'react';

import { EPriceDiff } from '../../../../types';
import * as styles from './styles.css';

export interface IPriceProps {
  diff?: EPriceDiff;
  subprice?: string | null;
  size?: 'M' | 'XS';
}

export const Price: React.FC<React.PropsWithChildren<IPriceProps>> = ({ children, diff, subprice, size }) => {
  const Heading = size === 'M' ? UIHeading2 : UIHeading4;

  return (
    <div>
      <div className={styles['price']}>
        <Heading>{children}</Heading>
        {diff && diff !== EPriceDiff.NoChange && (
          <div
            style={{ transform: diff === EPriceDiff.Increase ? 'rotate(180deg)' : undefined }}
            data-testid={`price_diff_${diff}`}
          >
            <IconFinanceArrowBoldDown16
              color={diff === EPriceDiff.Increase ? 'icon-negative-default' : 'icon-positive-default'}
              display="block"
            />
          </div>
        )}
      </div>
      {subprice && <UIText2 color="gray60_100">{subprice}</UIText2>}
    </div>
  );
};
